import React from 'react'
import { Link } from 'react-router'
import EditIcon from '../../../img/icons/general-icons/icon_edit.png'

export default class LinkUpdateGroup extends React.Component {
  render () {
    var url = 'group/' + this.props.rowData.Nombre
    return (
      <Link to={url}>
        <img src={EditIcon}/>
      </Link>
    )
  }
}

/* Validate Props */
LinkUpdateGroup.propTypes = {
  rowData: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Group/SearchGroup/LinkUpdateGroup.js